export interface LocationFieldConfig {
  label: string;
  error: string;
  invalid: string;
  emptyData: string;
  required: boolean;
}

export const DEFAULT_LOCATION_CONFIG: LocationFieldConfig = {
  label: 'Ville',
  error: 'Veuillez saisir la ville où se situe le poste',
  emptyData: "Vérifiez qu'il s'agisse bien d'une ville ou qu'elle ne comporte pas de faute.",
  invalid: "La ville n'est pas valide",
  required: false,
};
